var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19727 6.00188V11.0019H6.77927M6.77927 11.0019C7.44311 9.36001 8.63295 7.98479 10.1623 7.09174C11.6916 6.19869 13.4741 5.83829 15.2302 6.06702C16.9864 6.29575 18.6171 7.10068 19.8666 8.35566C21.1162 9.61064 21.9141 11.2447 22.1353 13.0019M6.77927 11.0019H11.1973M22.1973 22.0019V17.0019H21.6163M21.6163 17.0019C20.9515 18.6428 19.7613 20.0169 18.2321 20.9092C16.7029 21.8014 14.921 22.1614 13.1654 21.9328C11.4097 21.7041 9.77946 20.8998 8.5298 19.6456C7.28014 18.3915 6.48162 16.7583 6.25927 15.0019M21.6163 17.0019H17.1973",
    stroke: "#565556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.e9b64534b55796912075c25938ce7ed5.svg";
export { ForwardRef as ReactComponent };